import DbManagerService from '@/services/benchmarks/DbManagerService';

export class GetColorList {
  static async execute() {
    const { data } = await DbManagerService.getColors();

    return {
      colorList: data,
    };
  }
}
